import React from 'react';
import SalesInvoiceForm from './SalesInvoiceForm'; // Adjust path

const NewSalesInvoicePage = () => {
    // Renders the form in 'create' mode
    return <SalesInvoiceForm formType="create" currentInvoiceId={null} />;
};

export default NewSalesInvoicePage;